$(function (){
    /* video */
    $('.video-conflict-social').on('click', function () {
        $(this).fadeOut();
        playVideo();
    });
});